<button matRipple (click)="openEditContentPage()" class="button"
  [title]="'new_event.edit_content_button' | translate">
  {{ 'page.detail.buttons.title_edit' | translate }}
</button>
